import { PlantExtIdsModel } from './plant-external-ids.model';
import { PlantDetailsModel } from './plant-details.models';
import { DEFAULT_PAGE_SIZE, ListQueryParam } from '../../../../../common/constants';
import { PlantListFiltersModelBase } from '../constants';

export class PlantBrief {
  id: number;
  plantShortName: string;
  plantFullName: string;
  sapPlantId: string;
  sapSystem: string;
}

export class PlantListSearchCriteria extends PlantListFiltersModelBase {
  [ListQueryParam.Size] = DEFAULT_PAGE_SIZE;
  [ListQueryParam.Page] = 0;
  constructor(params?: PlantListSearchCriteria) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class PlantModel extends PlantBrief {
  extIds: PlantExtIdsModel[];

  constructor(params?: PlantBrief) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class PlantRequestModel {
  constructor(plantDetails: Partial<PlantDetailsModel>, extIds: PlantExtIdsModel[]) {
    if (plantDetails && extIds) {
      Object.assign(this, plantDetails, { extIds });
    }
  }
}
